import { render, staticRenderFns } from "./AppointmentTime.vue?vue&type=template&id=3caf0520&"
import script from "./AppointmentTime.vue?vue&type=script&lang=js&"
export * from "./AppointmentTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports